
const Header = () => {
  return (
    <>
      <div className="navbar">
        <a href="/">Home</a>
        <a href='/Portfolio_of_oil_painting_artist_Xing_Qingxin.pdf' target='_blank'>Portfolio Of Qingxin Xing</a>
      </div>
    </>
  )
}

export default Header;